module.exports = __webpack_public_path__ + "media/images/shin-a2fe2c4ceb7a3536f5e8e2aae0383eff.png";